import type { SystemVersionDTO } from "@repo/codegen/teashop-base-api"
import type * as CashierSettings from "./type/cashierSettings"
import type { CallerHandledAuthFailureOptions } from "@/utils/callerHandledAuthFailure"
import { getCallerHandledAuthFailureConfig } from "@/utils/callerHandledAuthFailure"
import { request } from "@/utils/service"

const PREFIX = "teashop_merchant/"

/**
 * 启用，关闭交接班
 */
export function openOrCloseShift(status: string) {
  return request<IApiResponseData<boolean>>({
    url: `${PREFIX}merchant_shop/shift_handover/${status}`,
    method: "PATCH",
  })
}

/**
 * 获取开班状态
 *
 * @return 是否开班
 */
export function getShiftHandoverStatus() {
  return request<IApiResponseData<boolean>>({
    url: `${PREFIX}merchant_shop/shift_handover`,
    method: "GET",
  })
}

/**
 * 设置是否允许非开班人交班
 */
export function updateShiftHandoverAllowNonOpenUserStatus(status: string) {
  return request<IApiResponseData<boolean>>({
    url: `${PREFIX}merchant_shop/shift_handover_allow_non_open_user/${status}`,
    method: "PATCH",
  })
}

/**
 * 获取是否允许非开班人交班
 */
export function getShiftHandoverAllowNonOpenUserStatus() {
  return request<IApiResponseData<boolean>>({
    url: `${PREFIX}merchant_shop/shift_handover_allow_non_open_user`,
    method: "GET",
  })
}

/**
 * 设置是否允许修改交接班业务截止时间。
 */
export function updateShiftHandoverTimeEditableStatus(status: string) {
  return request<IApiResponseData<boolean>>({
    url: `${PREFIX}merchant_shop/shift_handover_time_editable/${status}`,
    method: "PATCH",
  })
}

/**
 * 获取是否允许修改交接班业务截止时间（后端默认关闭）。
 */
export function getShiftHandoverTimeEditableStatus() {
  return request<IApiResponseData<boolean>>({
    url: `${PREFIX}merchant_shop/shift_handover_time_editable`,
    method: "GET",
  })
}

// 修改默认营业时间
export function modifyDefaultBussinessDate(time: number) {
  return request<IApiResponseData<boolean>>({
    url: `${PREFIX}/merchant_shop_business_info/businessTime`,
    method: "PUT",
    data: {
      businessStartTime: time,
      businessEndTime: time,
    },
  })
}

// 通过shopId获取商户收款信息,拿到当前营业统计开始时间
export function getNowBussinessDate(options: CallerHandledAuthFailureOptions & {
  businessContextSystemVersion?: SystemVersionDTO
} = {}) {
  return request<IApiResponseData<CashierSettings.MerchantShopBusinessInfo>>({
    url: `${PREFIX}/merchant_shop_business_info/get_by_shop_id`,
    method: "GET",
    businessContextSystemVersion: options.businessContextSystemVersion,
    ...getCallerHandledAuthFailureConfig(options),
  })
}
